export const dialogWindowConfig = {
  small: {
    minWidth: '345px',
    maxWidth: '500px',
    width: '90vw',
    maxHeight: '85dvh',
  },
  medium: {
    minWidth: '345px',
    maxWidth: '550px',
    width: '90vw',
  },
  large: {
    minWidth: '345px',
    maxWidth: '765px',
    width: '90vw',
  },
} as const;
